import confetti from 'canvas-confetti';
import { toast } from 'sonner';

export const celebrateAchievement = (achievement) => {
  if (!achievement) return;
  // Confetti burst
  const duration = 2500;
  const end = Date.now() + duration;
  const colors = ['#FFD700', '#FF6B9D', '#A78BFA', '#34D399', '#60A5FA'];
  (function frame() {
    confetti({ particleCount: 4, angle: 60, spread: 60, origin: { x: 0, y: 0.7 }, colors });
    confetti({ particleCount: 4, angle: 120, spread: 60, origin: { x: 1, y: 0.7 }, colors });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
  // Center burst
  confetti({ particleCount: 80, spread: 90, origin: { y: 0.6 }, colors, scalar: 1.2 });

  // Big toast
  toast.success(achievement.title, {
    description: achievement.description,
    duration: 6000,
    style: {
      background: 'linear-gradient(135deg, #1f1830 0%, #050505 100%)',
      border: '1px solid rgba(255,215,0,0.5)',
      color: '#fff',
      fontSize: '15px',
    }
  });
};

export const celebrateMany = (achievements = []) => {
  achievements.forEach((a, i) => setTimeout(() => celebrateAchievement(a), i * 600));
};
